// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../imgs/ic-arrow-drop-down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../imgs/ic-check-white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../imgs/ic-check-default.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../imgs/ic-check-negative.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../imgs/ic-check-grey.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TbYev9AlDvmPvyhWBogl label {
  font-size: var(--step--1);
  line-height: 1.25;
  font-weight: 700;
  color: var(--label-color);
  text-transform: uppercase;
}

:root {
  --form-bg-color: var(--xlt-grey-color);
  --legend-color: var(--primary-color);
  --label-color: var(--secondary-alt-color);
  --label-color-lighter: var(--form-accent-color-lighter);
  --input-width: 100%;
  --input-min-width: var(--space-3xl);
  --input-max-width: 100%;
  --input-font-size: var(--base-font-size);
  --input-font-weight: normal;
  --input-color: var(--text-dark-color);
  --input-bg-color: rgba(255, 255, 255, 0.85);
  --input-bg-color-transparent: rgba(255, 255, 255, 0.75);
  --input-bg-color-darker: hsl(218.9, 100%, calc(17.84% + 72%));
  --input-bg-color-hover: var(--form-accent-color-lighter);
  --input-bg-color-focus: var(--input-bg-color);
  --input-border-width: 2px;
  --input-border-style: solid;
  --input-border-color: var(--primary-color);
  --input-padding-rl: var(--space-xs);
  --input-file-color: var(--helper-text-color);
  --input-file-border-width: var(--input-border-width);
  --input-file-border-style: var(--input-border-style);
  --input-file-border-color: var(--input-border-color);
  --select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  --select-bg-repeat: no-repeat;
  --select-bg-position: right top;
  --select-padding-r: 3em;
  --select-bg-size: contain;
  --range-padding: var(--space-m) var(--input-padding-rl)
    calc(var(--space-m) + var(--space-3xs));
  --range-track-height: 1em;
  --range-track-border-radius: 1em;
  --range-track-background: var(--grey-color);
  --range-thumb-width: 2.5em;
  --range-thumb-height: 2.5em;
  --range-thumb-background: var(--button-color);
  --range-thumb-border: var(--button-color);
  --range-thumb-border-radius: 2.5em;
  --range-thumb-box-shadow: 0 0.25em 0.5em 0 rgba(0, 0, 0, 0.25);
  --input-checkbox-check-light: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat
    right top;
  --input-checkbox-check-dark: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat
    right top;
  --input-checkbox-check-error: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat
    right top;
  --input-checkbox-check-disabled: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat
    right top;
  --input-checkbox-check-bg-size: contain;
  --input-border-color-hover: var(--form-accent-color);
  --input-border-color-focus: var(--form-accent-color);
  --input-border-radius: 0.25em;
  --input-padding-tb: var(--space-xs);
}

.TbYev9AlDvmPvyhWBogl label {
  color: var(--label-color);
  display: block;
}

.TbYev9AlDvmPvyhWBogl input {
  width: var(--input-width);
  min-width: var(--input-min-width);
  max-width: var(--input-max-width);
  font-size: var(--input-font-size);
  font-weight: var(--input-font-weight);
  color: var(--input-color);
  background-color: var(--input-bg-color);
  border-width: var(--input-border-width);
  border-style: var(--input-border-style);
  border-color: var(--input-border-color);
  border-radius: var(--input-border-radius);
  padding: var(--input-padding-tb) var(--input-padding-rl);
  margin-top: var(--input-margin-t);
  margin-right: var(--input-margin-r);
  margin-bottom: var(--input-margin-b);
  margin-left: var(--input-margin-l);
}

.TbYev9AlDvmPvyhWBogl input:hover {
  background-color: var(--input-bg-color-hover);
  border-color: var(--input-border-color-hover);
}

.TbYev9AlDvmPvyhWBogl input:focus {
  background-color: var(--input-bg-color-focus);
  border-color: var(--input-border-color-focus);
}

.TbYev9AlDvmPvyhWBogl input:focus-visible {
  outline-width: var(--focus-visible-outline-width);
  outline-style: var(--focus-visible-outline-style);
  outline-color: var(--focus-visible-outline-color);
}

.TbYev9AlDvmPvyhWBogl .keIdQT1EeUoZCj6aj6DF::after {
  display: inline-block;
  content: "*";
  color: var(--negative-color);
  font-size: 120%;
  font-weight: 700;
  padding: 0.125em;
}
`, "",{"version":3,"sources":["webpack://./src/widgets/forms/Input.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,yCAAyC;EACzC,uDAAuD;EACvD,mBAAmB;EACnB,mCAAmC;EACnC,uBAAuB;EACvB,wCAAwC;EACxC,2BAA2B;EAC3B,qCAAqC;EACrC,2CAA2C;EAC3C,uDAAuD;EACvD,6DAA6D;EAC7D,wDAAwD;EACxD,6CAA6C;EAC7C,yBAAyB;EACzB,2BAA2B;EAC3B,0CAA0C;EAC1C,mCAAmC;EACnC,4CAA4C;EAC5C,oDAAoD;EACpD,oDAAoD;EACpD,oDAAoD;EACpD,wDAAuD;EACvD,6BAA6B;EAC7B,+BAA+B;EAC/B,uBAAuB;EACvB,yBAAyB;EACzB;2CACyC;EACzC,yBAAyB;EACzB,gCAAgC;EAChC,2CAA2C;EAC3C,0BAA0B;EAC1B,2BAA2B;EAC3B,6CAA6C;EAC7C,yCAAyC;EACzC,kCAAkC;EAClC,8DAA8D;EAC9D;aACW;EACX;aACW;EACX;aACW;EACX;aACW;EACX,uCAAuC;EACvC,oDAAoD;EACpD,oDAAoD;EACpD,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,qCAAqC;EACrC,yBAAyB;EACzB,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,yCAAyC;EACzC,wDAAwD;EACxD,iCAAiC;EACjC,mCAAmC;EACnC,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,6CAA6C;EAC7C,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;EAC7C,6CAA6C;AAC/C;;AAEA;EACE,iDAAiD;EACjD,iDAAiD;EACjD,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".inputGroup label {\n  font-size: var(--step--1);\n  line-height: 1.25;\n  font-weight: 700;\n  color: var(--label-color);\n  text-transform: uppercase;\n}\n\n:root {\n  --form-bg-color: var(--xlt-grey-color);\n  --legend-color: var(--primary-color);\n  --label-color: var(--secondary-alt-color);\n  --label-color-lighter: var(--form-accent-color-lighter);\n  --input-width: 100%;\n  --input-min-width: var(--space-3xl);\n  --input-max-width: 100%;\n  --input-font-size: var(--base-font-size);\n  --input-font-weight: normal;\n  --input-color: var(--text-dark-color);\n  --input-bg-color: rgba(255, 255, 255, 0.85);\n  --input-bg-color-transparent: rgba(255, 255, 255, 0.75);\n  --input-bg-color-darker: hsl(218.9, 100%, calc(17.84% + 72%));\n  --input-bg-color-hover: var(--form-accent-color-lighter);\n  --input-bg-color-focus: var(--input-bg-color);\n  --input-border-width: 2px;\n  --input-border-style: solid;\n  --input-border-color: var(--primary-color);\n  --input-padding-rl: var(--space-xs);\n  --input-file-color: var(--helper-text-color);\n  --input-file-border-width: var(--input-border-width);\n  --input-file-border-style: var(--input-border-style);\n  --input-file-border-color: var(--input-border-color);\n  --select-bg-img: url(../../imgs/ic-arrow-drop-down.svg);\n  --select-bg-repeat: no-repeat;\n  --select-bg-position: right top;\n  --select-padding-r: 3em;\n  --select-bg-size: contain;\n  --range-padding: var(--space-m) var(--input-padding-rl)\n    calc(var(--space-m) + var(--space-3xs));\n  --range-track-height: 1em;\n  --range-track-border-radius: 1em;\n  --range-track-background: var(--grey-color);\n  --range-thumb-width: 2.5em;\n  --range-thumb-height: 2.5em;\n  --range-thumb-background: var(--button-color);\n  --range-thumb-border: var(--button-color);\n  --range-thumb-border-radius: 2.5em;\n  --range-thumb-box-shadow: 0 0.25em 0.5em 0 rgba(0, 0, 0, 0.25);\n  --input-checkbox-check-light: url(../../imgs/ic-check-white.svg) no-repeat\n    right top;\n  --input-checkbox-check-dark: url(../../imgs/ic-check-default.svg) no-repeat\n    right top;\n  --input-checkbox-check-error: url(../../imgs/ic-check-negative.svg) no-repeat\n    right top;\n  --input-checkbox-check-disabled: url(../../imgs/ic-check-grey.svg) no-repeat\n    right top;\n  --input-checkbox-check-bg-size: contain;\n  --input-border-color-hover: var(--form-accent-color);\n  --input-border-color-focus: var(--form-accent-color);\n  --input-border-radius: 0.25em;\n  --input-padding-tb: var(--space-xs);\n}\n\n.inputGroup label {\n  color: var(--label-color);\n  display: block;\n}\n\n.inputGroup input {\n  width: var(--input-width);\n  min-width: var(--input-min-width);\n  max-width: var(--input-max-width);\n  font-size: var(--input-font-size);\n  font-weight: var(--input-font-weight);\n  color: var(--input-color);\n  background-color: var(--input-bg-color);\n  border-width: var(--input-border-width);\n  border-style: var(--input-border-style);\n  border-color: var(--input-border-color);\n  border-radius: var(--input-border-radius);\n  padding: var(--input-padding-tb) var(--input-padding-rl);\n  margin-top: var(--input-margin-t);\n  margin-right: var(--input-margin-r);\n  margin-bottom: var(--input-margin-b);\n  margin-left: var(--input-margin-l);\n}\n\n.inputGroup input:hover {\n  background-color: var(--input-bg-color-hover);\n  border-color: var(--input-border-color-hover);\n}\n\n.inputGroup input:focus {\n  background-color: var(--input-bg-color-focus);\n  border-color: var(--input-border-color-focus);\n}\n\n.inputGroup input:focus-visible {\n  outline-width: var(--focus-visible-outline-width);\n  outline-style: var(--focus-visible-outline-style);\n  outline-color: var(--focus-visible-outline-color);\n}\n\n.inputGroup .required::after {\n  display: inline-block;\n  content: \"*\";\n  color: var(--negative-color);\n  font-size: 120%;\n  font-weight: 700;\n  padding: 0.125em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputGroup": `TbYev9AlDvmPvyhWBogl`,
	"required": `keIdQT1EeUoZCj6aj6DF`
};
export default ___CSS_LOADER_EXPORT___;
